<template>
  <div class="import-modals">
    <confirmation-modal
      :cancel="close"
      :confirm="deleteRow"
      title="Confirme exclusão do Supervisor"
      message="Tem certeza que deseja excluir esse Supervisor?"
    />
  </div>
</template>

<script>
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import SupervisorActions from './SupervisorActions';

export default {
  name: 'supervisor-imports',
  mixins: [SupervisorActions],
  components: {
    ConfirmationModal,
  },
};
</script>
